<div class="l-section u-mt-sp-32 u-mt-tb-40 u-mt-pc-56">
  <!-- [見出し領域] -->
  <div class="p-heading-area01">
    <h2 class="p-heading-area01__title c-heading-2">{{ 'heading.mailRecipient1' | staticMsg }}</h2>
  </div>
  <!-- //[見出し領域] -->
  <div class="p-form-layout01">
    <div class="p-form-layout01__item">
      <h3 class="p-form-layout01__item-title p-form-layout01__item-title--l">
        {{ 'label.requestMailAddress2' | staticMsg }}
      </h3>
      <div class="p-input-block01">
        <div class="p-input-block01__item">
          <div class="p-input-block01__row p-input-block01__row--has-title">
            <div class="p-input-block01__row-head">
              <span
                class="p-input-block01__row-title"
                [innerHTML]="'label.eMailAddress.passengerInput' | staticMsg"
              ></span>
              <span class="c-label-required" [innerHTML]="'message.mandatory' | staticMsg"></span>
            </div>
            <div class="p-input-block01__row-body">
              <form [formGroup]="paymentInputFG!">
                <div class="p-input-block01__row-body-item">
                  <div class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w325">
                    <div class="p-booking-info-mdl__row-item">
                      <span class="u-visually-hidden" [innerHTML]="'reader.eMailAddress' | staticMsg"> </span>
                      <asw-input
                        id="asw-service-request-payment-input-notification-address"
                        [label]="'label.eMailAddress' | staticMsg"
                        [placeholder]="'placeholder.eMailAddress' | staticMsg"
                        formControlName="notificationConfirmationEmail"
                        maxlength="50"
                        [conversionType]="'email'"
                        (change$)="emailChange()"
                      >
                      </asw-input>
                    </div>
                  </div>
                </div>
                <div class="p-input-block01__row-body-item">
                  <div class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w325">
                    <div class="c-form-element-input">
                      <div class="p-booking-info-mdl__row-item">
                        <div class="c-form-element-input">
                          <span class="u-visually-hidden" [innerHTML]="'reader.confirmMailAddress' | staticMsg"> </span>
                          <!-- [8.2] ペースト操作は不可とする。 -->
                          <asw-input
                            id="asw-service-request-payment-input-notification-address-confirm"
                            label="{{ 'label.confirmMailAddress' | staticMsg }}"
                            placeholder="{{ 'placeholder.eMailAddress' | staticMsg }}"
                            formControlName="notificationConfirmationConfirmEmail"
                            maxlength="50"
                            [conversionType]="'email'"
                            (change$)="emailChange()"
                            [disablePaste]="true"
                          ></asw-input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="p-form-layout01__item">
      <h3 class="p-form-layout01__item-title p-form-layout01__item-title--l">
        {{ this.passengerEmailDestinationHeading | staticMsg }}
      </h3>
      <div *ngFor="let traveler of pnrData?.travelers" class="p-input-block01">
        <asw-service-request-payment-input-notification-email [pnrData]="pnrData" [traveler]="traveler">
        </asw-service-request-payment-input-notification-email>
      </div>
    </div>

    <div class="p-form-layout01__item">
      <h3 class="p-form-layout01__item-title p-form-layout01__item-title--l">
        {{ this.passengerSmsDestinationHeading | staticMsg }}
      </h3>
      <div *ngFor="let traveler of pnrData?.travelers" class="p-input-block01">
        <asw-service-request-payment-input-notification-sms [traveler]="traveler" [pnrData]="pnrData">
        </asw-service-request-payment-input-notification-sms>
      </div>
    </div>
  </div>
</div>
